<template>
  <div class="score-card-container">

    <div class="turn-info-box">
      <button class="load-btn" @click="openLoadListModal">📂 불러오기</button>
<!--      <div class="turn-label">TURN</div>-->
      <div class="turn-number">
        <span class="current">{{ currentTurn }}</span> / 12
      </div>
      <button class="next-turn-btn" @click="nextTurn">
        다음 턴 ➔
      </button>

    </div>

    <svg
        class="interactive-svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 953.4 1027.2"
    >
      <g style="pointer-events: none;">
        <path class="cls-1" d="M1225.56,1178.36v82.4a1,1,0,0,1-1,1h-116.8a1,1,0,0,1-1-1v-82.4h118.8Z" transform="translate(-273.66 -236.06)"/>
        <polygon points="951.9 931.5 951.9 942.3 951.2 942.3 833.1 942.3 833.1 931.5 951.2 931.5 951.9 931.5"/>
        <polygon class="cls-1" points="951.9 880.2 951.9 931.5 951.2 931.5 833.1 931.5 833.1 880.2 951.2 880.2 951.9 880.2"/>
        <polygon class="cls-1" points="951.9 828.9 951.9 880.2 951.2 880.2 833.1 880.2 833.1 828.9 951.2 828.9 951.9 828.9"/>
        <polygon class="cls-1" points="951.9 775.8 951.9 828.9 951.2 828.9 833.1 828.9 833.1 775.8 951.2 775.8 951.9 775.8"/>
        <polygon class="cls-1" points="951.9 726.3 951.9 775.8 951.2 775.8 833.1 775.8 833.1 726.3 951.2 726.3 951.9 726.3"/>
        <polygon class="cls-1" points="951.9 675.9 951.9 726.3 951.2 726.3 833.1 726.3 833.1 675.9 951.2 675.9 951.9 675.9"/>
        <polygon points="951.9 661.5 951.9 675.9 951.2 675.9 833.1 675.9 833.1 661.5 951.2 661.5 951.9 661.5"/>
        <path class="cls-1" d="M1225.56,848.76v48.8h-118.8v-48.8a1,1,0,0,1,1-1h116.8A1,1,0,0,1,1225.56,848.76Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M1106.76,765.16v-44h118.8v91.4a1,1,0,0,1-1,1h-116.8a1,1,0,0,1-1-1Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="951.9 434.7 951.9 485.1 951.2 485.1 833.1 485.1 833.1 434.7 951.2 434.7 951.9 434.7"/>
        <polygon class="cls-1" points="951.9 386.1 951.9 434.7 951.2 434.7 833.1 434.7 833.1 386.1 951.2 386.1 951.9 386.1"/>
        <polygon class="cls-1" points="951.9 335.7 951.9 386.1 951.2 386.1 833.1 386.1 833.1 335.7 951.2 335.7 951.9 335.7"/>
        <polygon class="cls-1" points="951.9 281.7 951.9 335.7 951.2 335.7 833.1 335.7 833.1 281.7 951.2 281.7 951.9 281.7"/>
        <polygon class="cls-1" points="951.9 231.3 951.9 281.7 951.2 281.7 833.1 281.7 833.1 231.3 951.2 231.3 951.9 231.3"/>
        <polygon class="cls-1" points="951.9 178.2 951.9 231.3 951.2 231.3 833.1 231.3 833.1 178.2 951.2 178.2 951.9 178.2"/>
        <path class="cls-1" d="M1225.56,238.56v175.7h-118.8V238.56a1,1,0,0,1,1-1h116.8A1,1,0,0,1,1225.56,238.56Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M1106.76,848.76v48.8H988v-48.8a1,1,0,0,1,1-1h116.8A1,1,0,0,1,1106.76,848.76Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M1106.76,765.16v47.4a1,1,0,0,1-1,1H989a1,1,0,0,1-1-1v-47.4h118.8Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M1106.76,238.56v175.7H988V238.56a1,1,0,0,1,1-1h116.8A1,1,0,0,1,1106.76,238.56Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="833.1 178.2 833.1 231.3 832.4 231.3 714.3 231.3 714.3 178.2 714.5 178.2 832.4 178.2 833.1 178.2"/>
        <polygon class="cls-1" points="833.1 231.3 833.1 281.7 832.4 281.7 714.3 281.7 714.3 231.3 832.4 231.3 833.1 231.3"/>
        <polygon class="cls-1" points="833.1 281.7 833.1 335.7 832.4 335.7 714.3 335.7 714.3 281.7 832.4 281.7 833.1 281.7"/>
        <polygon class="cls-1" points="833.1 335.7 833.1 386.1 832.4 386.1 714.3 386.1 714.3 335.7 832.4 335.7 833.1 335.7"/>
        <polygon class="cls-1" points="833.1 386.1 833.1 434.7 832.4 434.7 714.3 434.7 714.3 386.1 832.4 386.1 833.1 386.1"/>
        <polygon class="cls-1" points="833.1 434.7 833.1 485.1 832.4 485.1 714.3 485.1 714.3 434.7 832.4 434.7 833.1 434.7"/>
        <polygon class="cls-2" points="833.1 485.1 833.1 529.1 827 529.1 714.3 529.1 714.3 485.1 832.4 485.1 833.1 485.1"/>
        <polygon points="833.1 661.5 833.1 675.9 832.4 675.9 714.3 675.9 714.3 661.5 832.4 661.5 833.1 661.5"/>
        <polygon class="cls-1" points="833.1 675.9 833.1 726.3 832.4 726.3 714.3 726.3 714.3 675.9 832.4 675.9 833.1 675.9"/>
        <polygon class="cls-1" points="833.1 726.3 833.1 775.8 832.4 775.8 714.3 775.8 714.3 726.3 832.4 726.3 833.1 726.3"/>
        <polygon class="cls-1" points="833.1 775.8 833.1 828.9 832.4 828.9 714.3 828.9 714.3 775.8 832.4 775.8 833.1 775.8"/>
        <polygon class="cls-1" points="833.1 828.9 833.1 880.2 832.4 880.2 714.3 880.2 714.3 828.9 832.4 828.9 833.1 828.9"/>
        <polygon class="cls-1" points="833.1 880.2 833.1 931.5 832.4 931.5 714.3 931.5 714.3 880.2 832.4 880.2 833.1 880.2"/>
        <polygon points="833.1 931.5 833.1 942.3 832.4 942.3 714.3 942.3 714.3 931.5 832.4 931.5 833.1 931.5"/>
        <path class="cls-1" d="M1106.06,1178.36h.7v82.4a1,1,0,0,1-1,1H989a1,1,0,0,1-1-1v-82.4Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M988,848.76v48.8H869.16v-48.8a1,1,0,0,1,1-1H987A1,1,0,0,1,988,848.76Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M988,765.16v47.4a1,1,0,0,1-1,1H870.16a1,1,0,0,1-1-1v-47.4H988Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M988,238.56v175.7H869.16V238.56a1,1,0,0,1,1-1H987A1,1,0,0,1,988,238.56Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="595.5 178.2 595.7 178.2 713.6 178.2 714.3 178.2 714.3 231.3 713.6 231.3 595.5 231.3 595.5 178.2"/>
        <polygon class="cls-1" points="714.3 231.3 714.3 281.7 713.6 281.7 595.5 281.7 595.5 231.3 713.6 231.3 714.3 231.3"/>
        <polygon class="cls-1" points="714.3 281.7 714.3 335.7 713.6 335.7 595.5 335.7 595.5 281.7 713.6 281.7 714.3 281.7"/>
        <polygon class="cls-1" points="714.3 335.7 714.3 386.1 713.6 386.1 595.5 386.1 595.5 335.7 713.6 335.7 714.3 335.7"/>
        <polygon class="cls-1" points="714.3 386.1 714.3 434.7 713.6 434.7 595.5 434.7 595.5 386.1 713.6 386.1 714.3 386.1"/>
        <polygon class="cls-1" points="714.3 434.7 714.3 485.1 713.6 485.1 595.5 485.1 595.5 434.7 713.6 434.7 714.3 434.7"/>
        <polygon class="cls-2" points="714.3 485.1 714.3 529.1 708.2 529.1 595.5 529.1 595.5 485.1 713.6 485.1 714.3 485.1"/>
        <polygon points="714.3 661.5 714.3 675.9 713.6 675.9 595.5 675.9 595.5 661.5 713.6 661.5 714.3 661.5"/>
        <polygon class="cls-1" points="714.3 675.9 714.3 726.3 713.6 726.3 595.5 726.3 595.5 675.9 713.6 675.9 714.3 675.9"/>
        <polygon class="cls-1" points="714.3 726.3 714.3 775.8 713.6 775.8 595.5 775.8 595.5 726.3 713.6 726.3 714.3 726.3"/>
        <polygon class="cls-1" points="714.3 775.8 714.3 828.9 713.6 828.9 595.5 828.9 595.5 775.8 713.6 775.8 714.3 775.8"/>
        <polygon class="cls-1" points="714.3 828.9 714.3 880.2 713.6 880.2 595.5 880.2 595.5 828.9 713.6 828.9 714.3 828.9"/>
        <polygon class="cls-1" points="713.6 880.2 714.3 880.2 714.3 931.5 713.6 931.5 595.5 931.5 595.5 880.2 713.6 880.2"/>
        <polygon points="713.6 931.5 714.3 931.5 714.3 942.3 713.6 942.3 595.5 942.3 595.5 931.5 713.6 931.5"/>
        <path class="cls-1" d="M987.26,1178.36h.7v82.4a1,1,0,0,1-1,1H870.16a1,1,0,0,1-1-1v-82.4Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M750.36,897.56v-48.8a1,1,0,0,1-1-1h116.8a1,1,0,0,1,1,1v48.8H750.36Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M750.36,812.56v-47.4h118.8v47.4a1,1,0,0,1-1,1H751.36A1,1,0,0,1,750.36,812.56Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M750.36,414.26V238.56a1,1,0,0,1-1-1h116.8a1,1,0,0,1,1,1v175.7H750.36Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="476.7 281.7 476.7 231.3 477.8 231.3 594.8 231.3 595.5 231.3 595.5 281.7 594.8 281.7 477.8 281.7 476.7 281.7"/>
        <polygon class="cls-1" points="476.7 335.7 476.7 281.7 477.8 281.7 594.8 281.7 595.5 281.7 595.5 335.7 594.8 335.7 477.8 335.7 476.7 335.7"/>
        <polygon class="cls-1" points="476.7 386.1 476.7 335.7 477.8 335.7 594.8 335.7 595.5 335.7 595.5 386.1 594.8 386.1 477.8 386.1 476.7 386.1"/>
        <polygon class="cls-1" points="476.7 434.7 476.7 386.1 477.8 386.1 594.8 386.1 595.5 386.1 595.5 434.7 594.8 434.7 477.8 434.7 476.7 434.7"/>
        <polygon class="cls-1" points="476.7 485.1 476.7 434.7 477.8 434.7 594.8 434.7 595.5 434.7 595.5 485.1 594.8 485.1 477.8 485.1 476.7 485.1"/>
        <polygon class="cls-2" points="476.7 529.1 476.7 485.1 477.8 485.1 594.8 485.1 595.5 485.1 595.5 529.1 589.4 529.1 485 529.1 476.7 529.1"/>
        <polygon points="476.7 675.9 476.7 661.5 477.8 661.5 594.8 661.5 595.5 661.5 595.5 675.9 594.8 675.9 477.8 675.9 476.7 675.9"/>
        <polygon class="cls-1" points="476.7 726.3 476.7 675.9 477.8 675.9 594.8 675.9 595.5 675.9 595.5 726.3 594.8 726.3 477.8 726.3 476.7 726.3"/>
        <polygon class="cls-1" points="476.7 775.8 476.7 726.3 477.8 726.3 594.8 726.3 595.5 726.3 595.5 775.8 594.8 775.8 477.8 775.8 476.7 775.8"/>
        <polygon class="cls-1" points="476.7 828.9 476.7 775.8 477.8 775.8 594.8 775.8 595.5 775.8 595.5 828.9 594.8 828.9 477.8 828.9 476.7 828.9"/>
        <polygon class="cls-1" points="476.7 880.2 476.7 828.9 477.8 828.9 594.8 828.9 595.5 828.9 595.5 880.2 594.8 880.2 477.8 880.2 476.7 880.2"/>
        <polygon class="cls-1" points="476.7 931.5 476.7 880.2 477.8 880.2 594.8 880.2 595.5 880.2 595.5 931.5 594.8 931.5 477.8 931.5 476.7 931.5"/>
        <polygon points="476.7 942.3 476.7 931.5 477.8 931.5 594.8 931.5 595.5 931.5 595.5 942.3 594.8 942.3 477.8 942.3 476.7 942.3"/>
        <path class="cls-1" d="M750.36,1260.76v-82.4h118.8v82.4a1,1,0,0,1-1,1H751.36A1,1,0,0,1,750.36,1260.76Z" transform="translate(-273.66 -236.06)"/><polygon class="cls-1" points="476.7 231.3 476.7 178.2 476.9 178.2 594.8 178.2 595.5 178.2 595.5 231.3 594.8 231.3 477.8 231.3 476.7 231.3"/>
        <rect class="cls-1" x="475.8" y="178.2" width="0.9" height="53.1"/><rect class="cls-1" x="475.8" y="231.3" width="0.9" height="50.4"/><rect class="cls-1" x="475.8" y="281.7" width="0.9" height="54"/><rect class="cls-1" x="475.8" y="335.7" width="0.9" height="50.4"/><rect class="cls-1" x="475.8" y="386.1" width="0.9" height="48.6"/><rect class="cls-1" x="475.8" y="434.7" width="0.9" height="50.4"/><rect class="cls-2" x="475.8" y="485.1" width="0.9" height="44"/><rect x="475.8" y="661.5" width="0.9" height="14.4"/><rect class="cls-1" x="475.8" y="675.9" width="0.9" height="50.4"/><rect class="cls-1" x="475.8" y="726.3" width="0.9" height="49.5"/><rect class="cls-1" x="475.8" y="775.8" width="0.9" height="53.1"/><rect class="cls-1" x="475.8" y="828.9" width="0.9" height="51.3"/><rect class="cls-1" x="475.8" y="880.2" width="0.9" height="51.3"/><rect x="475.8" y="931.5" width="0.9" height="10.8"/>
        <path class="cls-1" d="M630.66,897.56v-48.8a1,1,0,0,1-1,1h116.8a1,1,0,0,1,1,1v48.8H630.66Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M630.66,414.26V238.56a1,1,0,0,1-1-1h116.8a1,1,0,0,1,1,1v175.7H630.66Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M749.46,765.16v47.4a1,1,0,0,1-1,1H631.66a1,1,0,0,1-1-1v-47.4h118.8Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="357 281.7 357 231.3 359 231.3 475.1 231.3 475.8 231.3 475.8 281.7 475.1 281.7 359 281.7 357 281.7"/>
        <polygon class="cls-1" points="357 335.7 357 281.7 359 281.7 475.1 281.7 475.8 281.7 475.8 335.7 475.1 335.7 359 335.7 357 335.7"/>
        <polygon class="cls-1" points="475.8 335.7 475.8 386.1 475.1 386.1 359 386.1 357 386.1 357 335.7 359 335.7 475.1 335.7 475.8 335.7"/>
        <polygon class="cls-1" points="475.8 386.1 475.8 434.7 475.1 434.7 359 434.7 357 434.7 357 386.1 359 386.1 475.1 386.1 475.8 386.1"/>
        <polygon class="cls-1" points="475.8 434.7 475.8 485.1 475.1 485.1 359 485.1 357 485.1 357 434.7 359 434.7 475.1 434.7 475.8 434.7"/>
        <polygon class="cls-2" points="475.8 485.1 475.8 529.1 469.7 529.1 366.2 529.1 357 529.1 357 485.1 359 485.1 475.1 485.1 475.8 485.1"/>
        <polygon points="357 661.5 359 661.5 475.1 661.5 475.8 661.5 475.8 675.9 475.1 675.9 359 675.9 357 675.9 357 661.5"/>
        <polygon class="cls-1" points="357 675.9 359 675.9 475.1 675.9 475.8 675.9 475.8 726.3 475.1 726.3 359 726.3 357 726.3 357 675.9"/>
        <polygon class="cls-1" points="475.8 726.3 475.8 775.8 475.1 775.8 359 775.8 357 775.8 357 726.3 359 726.3 475.1 726.3 475.8 726.3"/>
        <polygon class="cls-1" points="475.8 775.8 475.8 828.9 475.1 828.9 359 828.9 357 828.9 357 775.8 359 775.8 475.1 775.8 475.8 775.8"/>
        <polygon class="cls-1" points="475.8 828.9 475.8 880.2 475.1 880.2 359 880.2 357 880.2 357 828.9 359 828.9 475.1 828.9 475.8 828.9"/>
        <polygon class="cls-1" points="475.8 880.2 475.8 931.5 475.1 931.5 359 931.5 357 931.5 357 880.2 359 880.2 475.1 880.2 475.8 880.2"/>
        <polygon points="475.8 931.5 475.8 942.3 475.1 942.3 359 942.3 357 942.3 357 931.5 359 931.5 475.1 931.5 475.8 931.5"/>
        <path class="cls-1" d="M749.46,1178.36v82.4a1,1,0,0,1-1,1H631.66a1,1,0,0,1-1-1v-82.4h118.8Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="358.1 178.2 475.1 178.2 475.8 178.2 475.8 231.3 475.1 231.3 359 231.3 357 231.3 357 178.2 358.1 178.2"/>
        <path class="cls-1" d="M511.86,897.56v-48.8a1,1,0,0,1-1-1h116.8a1,1,0,0,1,1,1v48.8H511.86Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M630.66,414.26H512.76V369.51a1,1,0,0,0-.9-1v-130a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M630.66,467.36H511.86V418.9a1,1,0,0,0,.9-1v-3.65h117.9Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M629.66,813.56H512.86a1,1,0,0,1-1-1v-47.4h118.8v47.4A1,1,0,0,1,629.66,813.56Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="240.2 231.3 357 231.3 357 281.7 240.2 281.7 238.2 281.7 238.2 231.3 240.2 231.3"/>
        <polygon class="cls-1" points="240.2 281.7 357 281.7 357 335.7 240.2 335.7 238.2 335.7 238.2 281.7 240.2 281.7"/>
        <polygon class="cls-1" points="240.2 335.7 357 335.7 357 386.1 240.2 386.1 238.2 386.1 238.2 335.7 240.2 335.7"/>
        <polygon class="cls-1" points="240.2 386.1 357 386.1 357 434.7 240.2 434.7 238.2 434.7 238.2 386.1 240.2 386.1"/>
        <polygon class="cls-1" points="240.2 434.7 357 434.7 357 485.1 240.2 485.1 238.2 485.1 238.2 434.7 240.2 434.7"/>
        <polygon class="cls-2" points="357 529.1 247.4 529.1 238.2 529.1 238.2 485.1 240.2 485.1 357 485.1 357 529.1"/>
        <polygon points="238.2 661.5 240.2 661.5 357 661.5 357 675.9 240.2 675.9 238.2 675.9 238.2 661.5"/>
        <polygon class="cls-1" points="238.2 675.9 240.2 675.9 357 675.9 357 726.3 240.2 726.3 238.2 726.3 238.2 675.9"/>
        <polygon class="cls-1" points="238.2 726.3 240.2 726.3 357 726.3 357 775.8 240.2 775.8 238.2 775.8 238.2 726.3"/>
        <polygon class="cls-1" points="238.2 775.8 240.2 775.8 357 775.8 357 828.9 240.2 828.9 238.2 828.9 238.2 775.8"/>
        <polygon class="cls-1" points="238.2 828.9 240.2 828.9 357 828.9 357 880.2 240.2 880.2 238.2 880.2 238.2 828.9"/>
        <polygon class="cls-1" points="238.2 880.2 240.2 880.2 357 880.2 357 931.5 240.2 931.5 238.2 931.5 238.2 880.2"/>
        <polygon points="238.2 931.5 240.2 931.5 357 931.5 357 942.3 240.2 942.3 238.2 942.3 238.2 931.5"/>
        <path class="cls-1" d="M511.86,1178.36h118.8v82.4a1,1,0,0,1-1,1H512.86a1,1,0,0,1-1-1Z" transform="translate(-273.66 -236.06)"/><path class="cls-1" d="M512.76,414.26v3.65a1,1,0,0,1-.9,1V368.52a1,1,0,0,1,.9,1Z" transform="translate(-273.66 -236.06)"/><path class="cls-3" d="M511,418.91v-50.4h.9V418.9H511Z" transform="translate(-273.66 -236.06)"/><rect class="cls-1" x="237.3" y="386.1" width="0.9" height="48.6"/><path class="cls-1" d="M395.06,897.56H275.16V849.21a1,1,0,0,1,1-1H510a1,1,0,0,1,1,1v48.35Z" transform="translate(-273.66 -236.06)"/><path class="cls-3" d="M511,418.91H278a1,1,0,0,1-1-1v-48.4a1,1,0,0,1,1-1H511Z" transform="translate(-273.66 -236.06)"/>
        <polygon class="cls-1" points="121.4 281.7 1.7 281.7 1.5 281.7 1.5 231.3 1.7 231.3 121.4 231.3 237.3 231.3 237.3 281.7 121.4 281.7"/>
        <polygon class="cls-1" points="121.4 335.7 1.7 335.7 1.5 335.7 1.5 281.7 1.7 281.7 121.4 281.7 237.3 281.7 237.3 335.7 121.4 335.7"/>
        <polygon class="cls-1" points="121.4 386.1 1.7 386.1 1.5 386.1 1.5 335.7 1.7 335.7 121.4 335.7 237.3 335.7 237.3 386.1 121.4 386.1"/>
        <polygon class="cls-1" points="121.4 434.7 1.7 434.7 1.5 434.7 1.5 386.1 1.7 386.1 121.4 386.1 237.3 386.1 237.3 434.7 121.4 434.7"/>
        <polygon class="cls-1" points="121.4 485.1 1.7 485.1 1.5 485.1 1.5 434.7 1.7 434.7 121.4 434.7 237.3 434.7 237.3 485.1 121.4 485.1"/>
        <polygon points="121.4 675.9 1.7 675.9 1.5 675.9 1.5 661.5 1.7 661.5 121.4 661.5 237.3 661.5 237.3 675.9 121.4 675.9"/>
        <polygon class="cls-1" points="121.4 726.3 1.7 726.3 1.5 726.3 1.5 675.9 1.7 675.9 121.4 675.9 237.3 675.9 237.3 726.3 121.4 726.3"/>
        <polygon class="cls-1" points="121.4 775.8 1.7 775.8 1.5 775.8 1.5 726.3 1.7 726.3 121.4 726.3 237.3 726.3 237.3 775.8 121.4 775.8"/>
        <polygon class="cls-1" points="121.4 828.9 1.7 828.9 1.5 828.9 1.5 775.8 1.7 775.8 121.4 775.8 237.3 775.8 237.3 828.9 121.4 828.9"/>
        <polygon class="cls-1" points="121.4 880.2 1.7 880.2 1.5 880.2 1.5 828.9 1.7 828.9 121.4 828.9 237.3 828.9 237.3 880.2 121.4 880.2"/>
        <polygon class="cls-1" points="121.4 931.5 1.7 931.5 1.5 931.5 1.5 880.2 1.7 880.2 121.4 880.2 237.3 880.2 237.3 931.5 121.4 931.5"/>
        <polygon points="121.4 942.3 1.7 942.3 1.5 942.3 1.5 931.5 1.7 931.5 121.4 931.5 237.3 931.5 237.3 942.3 121.4 942.3"/>
        <path class="cls-3" d="M510,1261.31H276.16a1,1,0,0,1-1-1v-82H511v82A1,1,0,0,1,510,1261.31Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-2" d="M510,813.56H276.16a1,1,0,0,1-1-1v-91.4H511v91.4A1,1,0,0,1,510,813.56Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-1" d="M395.06,467.36H275.16v-99.2a1,1,0,0,1,1-1H510a1,1,0,0,1,1,1v.35H278a1,1,0,0,0-1,1v48.4a1,1,0,0,0,1,1H511v48.45Z" transform="translate(-273.66 -236.06)"/>
        <line class="cls-4" x1="8.9" y1="529.1" x2="128.6" y2="529.1"/>
        <line class="cls-5" x1="1.7" y1="485.1" x2="121.4" y2="485.1"/>
        <line class="cls-5" x1="1.7" y1="434.7" x2="121.4" y2="434.7"/>
        <line class="cls-5" x1="1.7" y1="661.5" x2="121.4" y2="661.5"/>
        <line class="cls-5" x1="1.7" y1="675.9" x2="121.4" y2="675.9"/>
        <line class="cls-5" x1="1.7" y1="726.3" x2="121.4" y2="726.3"/>
        <line class="cls-5" x1="1.7" y1="775.8" x2="121.4" y2="775.8"/>
        <line class="cls-5" x1="1.7" y1="828.9" x2="121.4" y2="828.9"/>
        <line class="cls-5" x1="1.7" y1="880.2" x2="121.4" y2="880.2"/>
        <line class="cls-5" x1="1.7" y1="931.5" x2="121.4" y2="931.5"/>
        <line class="cls-5" x1="1.7" y1="942.3" x2="121.4" y2="942.3"/>
        <line class="cls-5" x1="1.7" y1="386.1" x2="121.4" y2="386.1"/>
        <line class="cls-5" x1="1.7" y1="335.7" x2="121.4" y2="335.7"/>
        <line class="cls-5" x1="1.7" y1="281.7" x2="121.4" y2="281.7"/>
        <line class="cls-5" x1="1.7" y1="231.3" x2="121.4" y2="231.3"/>
        <polyline class="cls-5" points="238.4 178.2 239.1 178.2 357 178.2 358.1 178.2"/>
        <path class="cls-6" d="M511,418.91V812.56a1,1,0,0,1-1,1H276.16a1,1,0,0,1-1-1V368.16a1,1,0,0,1,1-1H510a1,1,0,0,1,1,1v.35" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M511,418.91H278a1,1,0,0,1-1-1v-48.4a1,1,0,0,1,1-1h233.9" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M630.66,812.56a1,1,0,0,1-1,1H512.86a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M749.46,765.16v47.4a1,1,0,0,1-1,1H631.66a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1v526.6Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M511,1178.36v82a1,1,0,0,1-1,1H276.16a1,1,0,0,1-1-1V849.21a1,1,0,0,1,1-1H510a1,1,0,0,1,1,1v329.15Z" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M630.66,1260.76a1,1,0,0,1-1,1H512.86a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M749.46,1178.36v82.4a1,1,0,0,1-1,1H631.66a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1v329.6Z" transform="translate(-273.66 -236.06)"/>
        <polyline class="cls-4" points="128.6 529.1 237.3 529.1 238.2 529.1 247.4 529.1"/>
        <polyline class="cls-5" points="121.4 485.1 237.3 485.1 238.2 485.1 240.2 485.1"/>
        <polyline class="cls-5" points="121.4 434.7 237.3 434.7 238.2 434.7 240.2 434.7"/>
        <polyline class="cls-5" points="121.4 661.5 237.3 661.5 238.2 661.5 240.2 661.5"/>
        <polyline class="cls-5" points="121.4 675.9 237.3 675.9 238.2 675.9 240.2 675.9"/>
        <polyline class="cls-5" points="121.4 726.3 237.3 726.3 238.2 726.3 240.2 726.3"/>
        <polyline class="cls-5" points="121.4 775.8 237.3 775.8 238.2 775.8 240.2 775.8"/>
        <polyline class="cls-5" points="121.4 828.9 237.3 828.9 238.2 828.9 240.2 828.9"/>
        <polyline class="cls-5" points="121.4 880.2 237.3 880.2 238.2 880.2 240.2 880.2"/>
        <polyline class="cls-5" points="121.4 931.5 237.3 931.5 238.2 931.5 240.2 931.5"/>
        <polyline class="cls-5" points="121.4 942.3 237.3 942.3 238.2 942.3 240.2 942.3"/>
        <polyline class="cls-5" points="121.4 386.1 237.3 386.1 238.2 386.1 240.2 386.1"/>
        <polyline class="cls-5" points="121.4 335.7 237.3 335.7 238.2 335.7 240.2 335.7"/>
        <polyline class="cls-5" points="121.4 281.7 237.3 281.7 238.2 281.7 240.2 281.7"/>
        <polyline class="cls-5" points="121.4 231.3 237.3 231.3 238.2 231.3 240.2 231.3"/>
        <polyline class="cls-5" points="358.1 178.2 475.1 178.2 475.8 178.2 476.7 178.2 476.9 178.2"/>
        <path class="cls-6" d="M869.16,812.56a1,1,0,0,1-1,1H751.36a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M869.16,1260.76a1,1,0,0,1-1,1H751.36a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <polyline class="cls-4" points="247.4 529.1 357 529.1 366.2 529.1"/>
        <polyline class="cls-5" points="240.2 485.1 357 485.1 359 485.1"/>
        <polyline class="cls-5" points="240.2 434.7 357 434.7 359 434.7"/>
        <polyline class="cls-5" points="240.2 661.5 357 661.5 359 661.5"/>
        <polyline class="cls-5" points="240.2 675.9 357 675.9 359 675.9"/>
        <polyline class="cls-5" points="240.2 726.3 357 726.3 359 726.3"/>
        <polyline class="cls-5" points="240.2 775.8 357 775.8 359 775.8"/>
        <polyline class="cls-5" points="240.2 828.9 357 828.9 359 828.9"/>
        <polyline class="cls-5" points="240.2 880.2 357 880.2 359 880.2"/>
        <polyline class="cls-5" points="240.2 931.5 357 931.5 359 931.5"/>
        <polyline class="cls-5" points="240.2 942.3 357 942.3 359 942.3"/>
        <polyline class="cls-5" points="240.2 386.1 357 386.1 359 386.1"/>
        <polyline class="cls-5" points="240.2 335.7 357 335.7 359 335.7"/>
        <polyline class="cls-5" points="240.2 281.7 357 281.7 359 281.7"/>
        <polyline class="cls-5" points="240.2 231.3 357 231.3 359 231.3"/>
        <polyline class="cls-5" points="476.9 178.2 594.8 178.2 595.5 178.2 595.7 178.2"/>
        <path class="cls-6" d="M988,812.56a1,1,0,0,1-1,1H870.16a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1H987a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <path class="cls-6" d="M988,1260.76a1,1,0,0,1-1,1H870.16a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1H987a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/>
        <polyline class="cls-4" points="366.2 529.1 469.7 529.1 475.8 529.1 476.7 529.1 485 529.1"/>
        <polyline class="cls-5" points="359 485.1 475.1 485.1 475.8 485.1 476.7 485.1 477.8 485.1"/>
        <polyline class="cls-5" points="359 434.7 475.1 434.7 475.8 434.7 476.7 434.7 477.8 434.7"/>
        <polyline class="cls-5" points="359 661.5 475.1 661.5 475.8 661.5 476.7 661.5 477.8 661.5"/>
        <polyline class="cls-5" points="359 675.9 475.1 675.9 475.8 675.9 476.7 675.9 477.8 675.9"/>
        <polyline class="cls-5" points="359 726.3 475.1 726.3 475.8 726.3 476.7 726.3 477.8 726.3"/>
        <polyline class="cls-5" points="359 775.8 475.1 775.8 475.8 775.8 476.7 775.8 477.8 775.8"/>
        <polyline class="cls-5" points="359 828.9 475.1 828.9 475.8 828.9 476.7 828.9 477.8 828.9"/>
        <polyline class="cls-5" points="359 880.2 475.1 880.2 475.8 880.2 476.7 880.2 477.8 880.2"/>
        <polyline class="cls-5" points="359 931.5 475.1 931.5 475.8 931.5 476.7 931.5 477.8 931.5"/>
        <polyline class="cls-5" points="359 942.3 475.1 942.3 475.8 942.3 476.7 942.3 477.8 942.3"/>
        <polyline class="cls-5" points="359 386.1 475.1 386.1 475.8 386.1 476.7 386.1 477.8 386.1"/>
        <polyline class="cls-5" points="359 335.7 475.1 335.7 475.8 335.7 476.7 335.7 477.8 335.7"/>
        <polyline class="cls-5" points="359 281.7 475.1 281.7 475.8 281.7 476.7 281.7 477.8 281.7"/>
        <polyline class="cls-5" points="359 231.3 475.1 231.3 475.8 231.3 476.7 231.3 477.8 231.3"/>
        <polyline class="cls-5" points="595.7 178.2 713.6 178.2 714.3 178.2 714.5 178.2"/>
        <path class="cls-6" d="M1106.76,812.56a1,1,0,0,1-1,1H989a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/><path class="cls-6" d="M1106.76,1260.76a1,1,0,0,1-1,1H989a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1" transform="translate(-273.66 -236.06)"/><polyline class="cls-4" points="485 529.1 589.4 529.1 595.5 529.1 708.2 529.1 714.3 529.1 827 529.1 833.1 529.1 945.8 529.1"/><polyline class="cls-5" points="477.8 485.1 594.8 485.1 595.5 485.1 713.6 485.1 714.3 485.1 832.4 485.1 833.1 485.1 951.2 485.1"/><polyline class="cls-5" points="477.8 434.7 594.8 434.7 595.5 434.7 713.6 434.7 714.3 434.7 832.4 434.7 833.1 434.7 951.2 434.7"/><polyline class="cls-5" points="477.8 661.5 594.8 661.5 595.5 661.5 713.6 661.5 714.3 661.5 832.4 661.5 833.1 661.5 951.2 661.5"/><polyline class="cls-5" points="477.8 675.9 594.8 675.9 595.5 675.9 713.6 675.9 714.3 675.9 832.4 675.9 833.1 675.9 951.2 675.9"/><polyline class="cls-5" points="477.8 726.3 594.8 726.3 595.5 726.3 713.6 726.3 714.3 726.3 832.4 726.3 833.1 726.3 951.2 726.3"/><polyline class="cls-5" points="477.8 775.8 594.8 775.8 595.5 775.8 713.6 775.8 714.3 775.8 832.4 775.8 833.1 775.8 951.2 775.8"/><polyline class="cls-5" points="477.8 828.9 594.8 828.9 595.5 828.9 713.6 828.9 714.3 828.9 832.4 828.9 833.1 828.9 951.2 828.9"/><polyline class="cls-5" points="477.8 880.2 594.8 880.2 595.5 880.2 713.6 880.2 714.3 880.2 832.4 880.2 833.1 880.2 951.2 880.2"/><polyline class="cls-5" points="477.8 931.5 594.8 931.5 595.5 931.5 713.6 931.5 714.3 931.5 832.4 931.5 833.1 931.5 951.2 931.5"/><polyline class="cls-5" points="477.8 942.3 594.8 942.3 595.5 942.3 713.6 942.3 714.3 942.3 832.4 942.3 833.1 942.3 951.2 942.3"/><polyline class="cls-5" points="477.8 386.1 594.8 386.1 595.5 386.1 713.6 386.1 714.3 386.1 832.4 386.1 833.1 386.1 951.2 386.1"/><polyline class="cls-5" points="477.8 335.7 594.8 335.7 595.5 335.7 713.6 335.7 714.3 335.7 832.4 335.7 833.1 335.7 951.2 335.7"/><polyline class="cls-5" points="477.8 281.7 594.8 281.7 595.5 281.7 713.6 281.7 714.3 281.7 832.4 281.7 833.1 281.7 951.2 281.7"/><polyline class="cls-5" points="477.8 231.3 594.8 231.3 595.5 231.3 713.6 231.3 714.3 231.3 832.4 231.3 833.1 231.3 951.2 231.3"/><polyline class="cls-5" points="714.5 178.2 832.4 178.2 833.1 178.2 951.2 178.2"/><path class="cls-6" d="M1225.56,721.16v91.4a1,1,0,0,1-1,1h-116.8a1,1,0,0,1-1-1v-574a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1v482.6Z" transform="translate(-273.66 -236.06)"/><path class="cls-6" d="M1225.56,1178.36v82.4a1,1,0,0,1-1,1h-116.8a1,1,0,0,1-1-1v-412a1,1,0,0,1,1-1h116.8a1,1,0,0,1,1,1v329.6Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="192.23" width="29" height="29" rx="2.54"/><path d="M315.72,428.79a2,2,0,0,1,2,2v23.91a2.05,2.05,0,0,1-2,2.05H291.81a2,2,0,0,1-2-2.05V430.83a2,2,0,0,1,2-2h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3v23.91a3.05,3.05,0,0,0,3,3.05h23.91a3.06,3.06,0,0,0,3-3.05V430.83a3.05,3.05,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="30.11" cy="206.73" r="3.5"/><path class="cls-7" d="M303.77,439.79a3,3,0,1,1-3,3,3,3,0,0,1,3-3m0-1a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="242.81" width="29" height="29" rx="2.54"/><path d="M315.72,479.37a2.05,2.05,0,0,1,2,2.05v23.91a2,2,0,0,1-2,2H291.81a2,2,0,0,1-2-2V481.42a2,2,0,0,1,2-2.05h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3.05v23.91a3.05,3.05,0,0,0,3,3h23.91a3.05,3.05,0,0,0,3-3V481.42a3.06,3.06,0,0,0-3-3.05Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="264.31" r="2.5"/><path class="cls-7" d="M296.77,498.37a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="250.31" r="2.5"/><path class="cls-7" d="M310.77,484.37a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="293.4" width="29" height="29" rx="2.54"/><path d="M315.72,530a2.05,2.05,0,0,1,2,2v23.91a2.05,2.05,0,0,1-2,2H291.81a2,2,0,0,1-2-2V532a2,2,0,0,1,2-2h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3v23.91a3.05,3.05,0,0,0,3,3h23.91a3.05,3.05,0,0,0,3-3V532a3.06,3.06,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="314.9" r="2.5"/><path class="cls-7" d="M296.77,549a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="300.9" r="2.5"/><path class="cls-7" d="M310.77,535a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="30.11" cy="307.9" r="2.5"/><path class="cls-7" d="M303.77,542a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="343.99" width="29" height="29" rx="2.54"/><path d="M315.72,580.55a2.05,2.05,0,0,1,2,2V606.5a2.05,2.05,0,0,1-2,2H291.81a2,2,0,0,1-2-2V582.59a2,2,0,0,1,2-2h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3V606.5a3.05,3.05,0,0,0,3,3h23.91a3.06,3.06,0,0,0,3-3V582.59a3.05,3.05,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="365.49" r="2.5"/><path class="cls-7" d="M296.77,599.55a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="351.49" r="2.5"/><path class="cls-7" d="M310.77,585.55a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="365.49" r="2.5"/><path class="cls-7" d="M310.77,599.55a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="351.49" r="2.5"/><path class="cls-7" d="M296.77,585.55a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="394.58" width="29" height="29" rx="2.54"/><path d="M315.72,631.14a2,2,0,0,1,2,2v23.91a2.05,2.05,0,0,1-2,2H291.81a2,2,0,0,1-2-2V633.18a2,2,0,0,1,2-2h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3v23.91a3.05,3.05,0,0,0,3,3h23.91a3.06,3.06,0,0,0,3-3V633.18a3.05,3.05,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="416.08" r="2.5"/><path class="cls-7" d="M296.77,650.14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="402.08" r="2.5"/><path class="cls-7" d="M310.77,636.14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="30.11" cy="409.08" r="2.5"/><path class="cls-7" d="M303.77,643.14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="37.11" cy="416.08" r="2.5"/><path class="cls-7" d="M310.77,650.14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="23.11" cy="402.08" r="2.5"/><path class="cls-7" d="M296.77,636.14a2,2,0,1,1-2,2,2,2,0,0,1,2-2m0-1a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="445.16" width="29" height="29" rx="2.54"/><path d="M315.72,681.72a2.05,2.05,0,0,1,2,2v23.91a2,2,0,0,1-2,2H291.81a2,2,0,0,1-2-2V683.77a2,2,0,0,1,2-2h23.91m0-1H291.81a3.05,3.05,0,0,0-3,3v23.91a3.05,3.05,0,0,0,3,3h23.91a3.05,3.05,0,0,0,3-3V683.77a3.06,3.06,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="24.11" cy="466.66" r="2"/><path class="cls-7" d="M297.77,701.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="36.11" cy="452.66" r="2"/><path class="cls-7" d="M309.77,687.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="36.11" cy="459.66" r="2"/><path class="cls-7" d="M309.77,694.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="36.11" cy="466.66" r="2"/><path class="cls-7" d="M309.77,701.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="24.11" cy="452.66" r="2"/><path class="cls-7" d="M297.77,687.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><circle class="cls-7" cx="24.11" cy="459.66" r="2"/><path class="cls-7" d="M297.77,694.22a1.5,1.5,0,1,1-1.5,1.5,1.51,1.51,0,0,1,1.5-1.5m0-1a2.5,2.5,0,1,0,2.5,2.5,2.5,2.5,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="622.37" width="9" height="9" rx="2.5"/><path d="M295.77,858.93a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="642.37" width="9" height="9" rx="2.5"/><path d="M295.77,878.93a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="25.61" y="632.37" width="9" height="9" rx="2.5"/><path d="M305.77,868.93a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="35.61" y="622.37" width="9" height="9" rx="2.5"/><path d="M315.77,858.93a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="35.61" y="642.37" width="9" height="9" rx="2.5"/><path d="M315.77,878.93a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="685.5" width="9" height="9" rx="2.5"/><path d="M295.77,922.06a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="705.5" width="9" height="9" rx="2.5"/><path d="M295.77,942.06a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="35.61" y="685.5" width="9" height="9" rx="2.5"/><path d="M315.77,922.06a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="35.61" y="705.5" width="9" height="9" rx="2.5"/><path d="M315.77,942.06a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-4a2,2,0,0,1,2-2h4m0-1h-4a3,3,0,0,0-3,3v4a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3v-4a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="23.11" y="792.26" width="6.5" height="6.5" rx="2"/><path d="M301.27,1028.82a1.5,1.5,0,0,1,1.5,1.5v2.5a1.5,1.5,0,0,1-1.5,1.5h-2.5a1.5,1.5,0,0,1-1.5-1.5v-2.5a1.5,1.5,0,0,1,1.5-1.5h2.5m0-1h-2.5a2.51,2.51,0,0,0-2.5,2.5v2.5a2.5,2.5,0,0,0,2.5,2.5h2.5a2.51,2.51,0,0,0,2.5-2.5v-2.5a2.51,2.51,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><rect x="30.61" y="799.76" width="6.5" height="6.5" rx="2"/><path d="M308.77,1036.32a1.5,1.5,0,0,1,1.5,1.5v2.5a1.5,1.5,0,0,1-1.5,1.5h-2.5a1.5,1.5,0,0,1-1.5-1.5v-2.5a1.5,1.5,0,0,1,1.5-1.5h2.5m0-1h-2.5a2.51,2.51,0,0,0-2.5,2.5v2.5a2.5,2.5,0,0,0,2.5,2.5h2.5a2.51,2.51,0,0,0,2.5-2.5v-2.5a2.51,2.51,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><rect x="38.11" y="807.26" width="6.5" height="6.5" rx="2"/><path d="M316.27,1043.82a1.5,1.5,0,0,1,1.5,1.5v2.5a1.5,1.5,0,0,1-1.5,1.5h-2.5a1.5,1.5,0,0,1-1.5-1.5v-2.5a1.5,1.5,0,0,1,1.5-1.5h2.5m0-1h-2.5a2.51,2.51,0,0,0-2.5,2.5v2.5a2.5,2.5,0,0,0,2.5,2.5h2.5a2.51,2.51,0,0,0,2.5-2.5v-2.5a2.51,2.51,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="784.76" width="6.5" height="6.5" rx="2"/><path d="M293.77,1021.32a1.5,1.5,0,0,1,1.5,1.5v2.5a1.5,1.5,0,0,1-1.5,1.5h-2.5a1.5,1.5,0,0,1-1.5-1.5v-2.5a1.5,1.5,0,0,1,1.5-1.5h2.5m0-1h-2.5a2.51,2.51,0,0,0-2.5,2.5v2.5a2.5,2.5,0,0,0,2.5,2.5h2.5a2.51,2.51,0,0,0,2.5-2.5v-2.5a2.51,2.51,0,0,0-2.5-2.5Z" transform="translate(-273.66 -236.06)"/><rect x="20.9" y="741.48" width="7.82" height="7.82" rx="2.5"/><path d="M299.88,978a2,2,0,0,1,2,2v2.83a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2V980a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.83a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3V980a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="752.95" width="7.82" height="7.82" rx="2.5"/><path d="M294.59,989.51a2,2,0,0,1,2,2v2.83a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.83a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.83a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.83a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="31.49" y="741.48" width="7.82" height="7.82" rx="2.5"/><path d="M310.47,978a2,2,0,0,1,2,2v2.83a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2V980a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.83a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3V980a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="26.19" y="752.95" width="7.82" height="7.82" rx="2.5"/><path d="M305.18,989.51a2,2,0,0,1,2,2v2.83a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.83a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.83a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.83a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="36.78" y="752.95" width="7.82" height="7.82" rx="2.54"/><path d="M315.72,989.51a2.05,2.05,0,0,1,2,2v2.73a2.05,2.05,0,0,1-2,2.05H313a2.05,2.05,0,0,1-2.05-2.05v-2.73a2.05,2.05,0,0,1,2.05-2h2.73m0-1H313a3.06,3.06,0,0,0-3.05,3v2.73a3.06,3.06,0,0,0,3.05,3.05h2.73a3.06,3.06,0,0,0,3-3.05v-2.73a3.06,3.06,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="838.89" width="7.82" height="7.82" rx="2.5"/><path d="M294.59,1075.45a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="19.14" y="849.48" width="7.82" height="7.82" rx="2.5"/><path d="M298.12,1086a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2H295.3a2,2,0,0,1-2-2V1088a2,2,0,0,1,2-2h2.82m0-1H295.3a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3V1088a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="26.19" y="860.07" width="7.82" height="7.82" rx="2.5"/><path d="M305.18,1096.63a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="36.78" y="838.89" width="7.82" height="7.82" rx="2.5"/><path d="M315.77,1075.45a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.83a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.83m0-1h-2.83a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.83a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="33.25" y="849.48" width="7.82" height="7.82" rx="2.5"/><path d="M312.24,1086a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.83a2,2,0,0,1-2-2V1088a2,2,0,0,1,2-2h2.83m0-1h-2.83a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.83a3,3,0,0,0,3-3V1088a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.61" y="902.73" width="7.82" height="7.82" rx="2.5"/><path d="M294.59,1139.29a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="20.9" y="914.2" width="7.82" height="7.82" rx="2.5"/><path d="M299.88,1150.76a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="26.19" y="893.02" width="7.82" height="7.82" rx="2.5"/><path d="M305.18,1129.58a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.82a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.82m0-1h-2.82a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.82a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="36.78" y="902.73" width="7.82" height="7.82" rx="2.5"/><path d="M315.77,1139.29a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.83a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.83m0-1h-2.83a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.83a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="33.25" y="914.2" width="7.82" height="7.82" rx="2.5"/><path d="M312.24,1150.76a2,2,0,0,1,2,2v2.82a2,2,0,0,1-2,2h-2.83a2,2,0,0,1-2-2v-2.82a2,2,0,0,1,2-2h2.83m0-1h-2.83a3,3,0,0,0-3,3v2.82a3,3,0,0,0,3,3h2.83a3,3,0,0,0,3-3v-2.82a3,3,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><rect x="15.73" y="585.96" width="19" height="19" rx="2.54"/><path d="M305.84,822.52a2.05,2.05,0,0,1,2.05,2v13.91a2.05,2.05,0,0,1-2.05,2H291.93a2.05,2.05,0,0,1-2-2V824.56a2,2,0,0,1,2-2h13.91m0-1H291.93a3.05,3.05,0,0,0-3,3v13.91a3.05,3.05,0,0,0,3,3h13.91a3.06,3.06,0,0,0,3.05-3V824.56a3.05,3.05,0,0,0-3.05-3Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M298.89,833.68a2.17,2.17,0,1,1,2.16-2.16A2.17,2.17,0,0,1,298.89,833.68Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M298.89,829.85a1.67,1.67,0,1,1-1.67,1.67,1.66,1.66,0,0,1,1.67-1.67m0-1a2.67,2.67,0,1,0,2.66,2.67,2.68,2.68,0,0,0-2.66-2.67Z" transform="translate(-273.66 -236.06)"/><rect x="62.06" y="585.96" width="19" height="19" rx="2.54"/><path d="M352.18,822.52a2,2,0,0,1,2,2v13.91a2,2,0,0,1-2,2H338.27a2.05,2.05,0,0,1-2-2V824.56a2.05,2.05,0,0,1,2-2h13.91m0-1H338.27a3.05,3.05,0,0,0-3,3v13.91a3.06,3.06,0,0,0,3,3h13.91a3.05,3.05,0,0,0,3-3V824.56a3.05,3.05,0,0,0-3-3Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,837.35a1.17,1.17,0,1,1,1.17-1.17A1.16,1.16,0,0,1,341.22,837.35Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,835.52a.67.67,0,1,1-.66.66.67.67,0,0,1,.66-.66m0-1a1.67,1.67,0,1,0,1.67,1.66,1.66,1.66,0,0,0-1.67-1.66Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,828a1.17,1.17,0,1,1,1.17-1.17A1.16,1.16,0,0,1,349.22,828Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,826.18a.67.67,0,1,1-.66.67.67.67,0,0,1,.66-.67m0-1a1.67,1.67,0,1,0,1.67,1.67,1.66,1.66,0,0,0-1.67-1.67Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,832.68a1.17,1.17,0,1,1,1.17-1.16A1.16,1.16,0,0,1,349.22,832.68Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,830.85a.67.67,0,0,1,.67.67.67.67,0,1,1-.67-.67m0-1a1.67,1.67,0,1,0,1.67,1.67,1.66,1.66,0,0,0-1.67-1.67Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,837.35a1.17,1.17,0,1,1,1.17-1.17A1.16,1.16,0,0,1,349.22,837.35Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M349.22,835.52a.67.67,0,1,1-.66.66.67.67,0,0,1,.66-.66m0-1a1.67,1.67,0,1,0,1.67,1.66,1.66,1.66,0,0,0-1.67-1.66Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,828a1.17,1.17,0,1,1,1.17-1.17A1.16,1.16,0,0,1,341.22,828Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,826.18a.67.67,0,1,1-.66.67.67.67,0,0,1,.66-.67m0-1a1.67,1.67,0,1,0,1.67,1.67,1.66,1.66,0,0,0-1.67-1.67Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,832.68a1.17,1.17,0,1,1,1.17-1.16A1.16,1.16,0,0,1,341.22,832.68Z" transform="translate(-273.66 -236.06)"/><path class="cls-7" d="M341.22,830.85a.67.67,0,0,1,.67.67.67.67,0,1,1-.67-.67m0-1a1.67,1.67,0,1,0,1.67,1.67,1.66,1.66,0,0,0-1.67-1.67Z" transform="translate(-273.66 -236.06)"/><text class="cls-8" transform="translate(15.11 165.63)">족보명</text><text class="cls-9" transform="translate(77.63 216.15)">에이스</text><text class="cls-9" transform="translate(77.63 266.48)">듀스</text><text class="cls-9" transform="translate(77.63 367.14)">포</text><text class="cls-9" transform="translate(77.63 316.81)">트레이</text><text class="cls-9" transform="translate(77.63 417.47)">파이브</text><text class="cls-9" transform="translate(77.63 467.8)">식스</text><text class="cls-9" transform="translate(15.11 515.54)">소계</text><text class="cls-9" transform="translate(15.11 562.16)">보너스 + 35</text><text class="cls-10" transform="translate(42.29 600.81)">~</text><text class="cls-10" transform="translate(88.99 602.96)">의 합계가 63점 이상이면 보너스</text><text class="cls-8" transform="translate(15.11 994.27)">총합 득점</text><text class="cls-9" transform="translate(77.63 646.22)">초이스</text><text class="cls-9" transform="translate(77.63 711.34)">포 다이스</text><text class="cls-9" transform="translate(77.63 762.5)">풀 하우스</text><text class="cls-9" transform="translate(77.63 811.38)">S<tspan class="cls-11" x="15.19" y="0">.</tspan><tspan x="21.5" y="0" xml:space="preserve"> 스트레이트</tspan></text><text class="cls-9" transform="translate(77.63 864.81)">L<tspan class="cls-11" x="13.33" y="0">.</tspan><tspan x="19.64" y="0" xml:space="preserve"> 스트레이트</tspan></text><text class="cls-9" transform="translate(77.63 913.56)">요트</text>
      </g>


      <g v-for="(player, pIndex) in players" :key="`p-${pIndex}`">

        <text
            :x="297 + (pIndex * 119)"
            y="165"
            class="player-name-text"
        >
          {{ player.name }}
        </text>
        <rect
            :x="238 + (pIndex * 119)"
            y="135"
            width="116"
            height="40"
            class="click-area"
            @click="openNameModal(pIndex)"
        />

        <g v-for="(item, key) in scoreItems" :key="key">
          <text
              :x="297 + (pIndex * 119)"
              :y="item.y"
              class="score-text"
              :class="{
              'has-score': player.scores[key] !== null,
              'is-locked': player.locks[key]
            }"
          >
            {{ player.scores[key] !== null ? player.scores[key] : '' }}
          </text>

          <rect
              :x="238 + (pIndex * 119)"
              :y="item.y - 35"
              width="116"
              height="50"
              class="click-area"
              @click="openScoreModal(pIndex, key)"
          />
        </g>

        <text :x="297 + (pIndex * 119)" :y="515" class="total-text">{{ getUpperSum(pIndex) }}</text>
        <text :x="297 + (pIndex * 119)" :y="562" class="total-text bonus-text">{{ getBonus(pIndex) }}</text>
        <text :x="297 + (pIndex * 119)" :y="994" class="total-text grand-total">{{ getGrandTotal(pIndex) }}</text>

      </g>
    </svg>

    <div v-if="modal.isOpen" class="custom-modal-overlay" @click.self="closeModal">
      <div class="custom-modal">
        <h3>{{ modal.title }}</h3>

        <input
            v-if="modal.type === 'name'"
            ref="modalInput"
            type="text"
            v-model="modal.inputValue"
            placeholder="이름 입력"
            @keyup.enter="saveData"
        >

        <input
            v-if="modal.type === 'score'"
            ref="modalInput"
            type="number"
            pattern="[0-9]*"
            inputmode="decimal"
            v-model.number="modal.inputValue"
            placeholder="점수 입력"
            @keyup.enter="saveData"
        >
        <div v-if="modal.type === 'loadList'" class="game-list-container">

          <div class="list-filter">
            <label>
              <input type="checkbox" v-model="showFinishedGames" @change="fetchGameList">
              종료된 게임 보기
            </label>
          </div>

          <ul v-if="savedGames.length > 0">
            <li v-for="game in savedGames" :key="game.gameGroupId">
              <div class="game-info-wrapper" @click="selectGameToLoad(game.gameGroupId)">
                <div class="game-info">
                  <span class="game-date">{{ formatDate(game.updatedAt || game.startTime) }}</span>
                  <span class="game-turn" :class="{ 'text-finished': game.isFinished }">
                    {{ game.isFinished ? '게임 종료 (결과 보기)' : game.currentTurn + '턴 진행중' }}
                  </span>
                </div>
              </div>
              <button class="list-delete-btn" @click.stop="deleteSavedGame(game.gameGroupId)">삭제</button>
            </li>
          </ul>
          <div v-else class="no-data">
            {{ showFinishedGames ? '종료된 게임이 없습니다.' : '진행 중인 게임이 없습니다.' }}
          </div>
        </div>

        <div class="modal-buttons">
          <button v-if="modal.type === 'score'" class="btn-delete" @click="deleteScore">삭제</button>
          <button class="btn-cancel" @click="closeModal">취소</button>
          <button class="btn-confirm" @click="saveData">확인</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ScoreCardInteractive',
  data() {
    return {
      gameGroupId: null,
      userId: null,
      startTime: null,
      currentTurn: 1,
      isGameFinished: false,
      showFinishedGames: false,
      savedGames: [],
      modal: {
        isOpen: false,
        type: 'name',
        title: '',
        inputValue: '',
        targetIndex: null,
        targetKey: null
      },
      scoreItems: {
        aces: { label: '에이스', y: 216 },
        twos: { label: '듀스', y: 266 },
        threes: { label: '트레이', y: 316 },
        fours: { label: '포', y: 367 },
        fives: { label: '파이브', y: 417 },
        sixes: { label: '식스', y: 467 },
        choice: { label: '초이스', y: 646 },
        fourDice: { label: '포 다이스', y: 711 },
        fullHouse: { label: '풀 하우스', y: 762 },
        sStraight: { label: 'S. 스트레이트', y: 811 },
        lStraight: { label: 'L. 스트레이트', y: 864 },
        yacht: { label: '요트', y: 913 },
      },
      players: Array.from({ length: 6 }, (_, i) => ({
        id: i + 1,
        name: `Player ${i + 1}`,
        scores: {
          aces: null, twos: null, threes: null, fours: null, fives: null, sixes: null,
          choice: null, fourDice: null, fullHouse: null, sStraight: null, lStraight: null, yacht: null
        },
        locks: {
          aces: false, twos: false, threes: false, fours: false, fives: false, sixes: false,
          choice: false, fourDice: false, fullHouse: false, sStraight: false, lStraight: false, yacht: false
        }
      }))
    };
  },
  created() {
    this.userId = localStorage.getItem("userId");
    this.startTime = new Date().toISOString();
  },
  methods: {
    async nextTurn() {
      if (this.currentTurn >= 12) {
        await this.saveGameData(true);
        alert("게임이 종료되었습니다!");
        this.gameGroupId = null;
        this.currentTurn = 1;
        return;
      }

      if (!confirm(`${this.currentTurn}턴을 종료하시겠습니까?`)) {
        return;
      }

      this.players.forEach(player => {
        for (const key in player.scores) {
          if (player.scores[key] !== null) {
            player.locks[key] = true;
          }
        }
      });

      this.currentTurn++;
      await this.saveGameData(false);
    },

    async saveGameData(isFinished) {
      if (!this.userId) {
        console.log("로그인된 유저가 아니라서 저장하지 않습니다.");
        return;
      }

      const enrichedPlayersData = this.players.map((p, index) => ({
        ...p,
        calculated: {
          upperSum: this.getUpperSum(index),
          bonus: this.getBonus(index),
          grandTotal: this.getGrandTotal(index)
        }
      }));

      const payload = {
        userId: this.userId,
        gameGroupId: this.gameGroupId,
        currentTurn: this.currentTurn,
        isFinished: isFinished,
        startTime: this.startTime,
        endTime: new Date().toISOString(),
        players: enrichedPlayersData
      };

      try {
        const response = await this.$axios.post('/api/yacht/save', payload);
        if (!this.gameGroupId && response.data.gameGroupId) {
          this.gameGroupId = response.data.gameGroupId;
          console.log("새로운 게임 그룹 ID 발급 완료:", this.gameGroupId);
        }
        console.log("게임 데이터 저장 성공");
      } catch (error) {
        console.error("게임 저장 실패:", error);
        alert("데이터 저장 중 오류가 발생했습니다. 네트워크를 확인해주세요.");
      }
    },

    openLoadListModal() {
      if (!this.userId) {
        alert("로그인 정보가 없어 불러올 수 없습니다.");
        return;
      }
      this.modal.type = 'loadList';
      this.modal.title = '이어하기 / 결과 보기';
      this.modal.isOpen = true;
      this.showFinishedGames = false;
      this.fetchGameList();
    },

    async fetchGameList() {
      this.savedGames = [];
      try {
        const response = await this.$axios.get(`/api/yacht/list/${this.userId}`, {
          params: { isFinished: this.showFinishedGames }
        });
        this.savedGames = response.data;
      } catch (error) {
        console.error("목록 불러오기 실패:", error);
      }
    },

    async selectGameToLoad(targetId) {
      const selectedGame = this.savedGames.find(g => g.gameGroupId === targetId);
      const isFinished = selectedGame ? selectedGame.isFinished : false;

      let msg = "이 게임을 불러오시겠습니까?\n(현재 화면의 내용은 사라집니다)";
      if (isFinished) msg = "종료된 게임 결과를 보시겠습니까?";

      if(confirm(msg)) {
        await this.loadGameData(targetId);
        this.closeModal();
      }
    },

    async loadGameData(targetGameGroupId) {
      if (!this.userId) return;

      try {
        const response = await this.$axios.get(`/api/yacht/load/${targetGameGroupId}`);
        const data = response.data;

        this.gameGroupId = data.gameGroupId;
        this.currentTurn = data.currentTurn;
        this.startTime = data.startTime;
        this.isGameFinished = data.isFinished;

        if (data.playersData) {
          const parsedPlayers = (typeof data.playersData === 'string')
              ? JSON.parse(data.playersData)
              : data.playersData;
          this.players = parsedPlayers;
        } else if (data.players) {
          this.players = data.players;
        }
      } catch (error) {
        console.error("로드 에러:", error);
        alert("불러오기 실패");
      }
    },

    async deleteSavedGame(targetId) {
      if (!confirm("정말 이 게임 기록을 영구적으로 삭제하시겠습니까?")) {
        return;
      }

      try {
        await this.$axios.delete(`/api/yacht/delete/${targetId}`);
        this.savedGames = this.savedGames.filter(game => game.gameGroupId !== targetId);

        if (this.gameGroupId === targetId) {
          this.gameGroupId = null;
        }
      } catch (error) {
        console.error("삭제 실패:", error);
        alert("삭제 중 오류가 발생했습니다.");
      }
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '-';
      return date.toLocaleString('ko-KR', {
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    },

    openNameModal(pIndex) {
      this.modal.type = 'name';
      this.modal.title = `플레이어 ${pIndex + 1} 이름 변경`;
      this.modal.inputValue = '';
      this.modal.targetIndex = pIndex;
      this.modal.isOpen = true;
      this.$nextTick(() => { if(this.$refs.modalInput) this.$refs.modalInput.focus(); });
    },

    openScoreModal(pIndex, key) {
      if (this.isGameFinished) return;
      const player = this.players[pIndex];

      if (player.locks[key]) {
        alert("이전 턴에 확정된 점수는 수정할 수 없습니다.");
        return;
      }

      const itemName = this.scoreItems[key].label;
      this.modal.type = 'score';
      this.modal.title = `[${player.name}] ${itemName}`;
      this.modal.inputValue = '';
      this.modal.targetIndex = pIndex;
      this.modal.targetKey = key;
      this.modal.isOpen = true;
      this.$nextTick(() => { if(this.$refs.modalInput) this.$refs.modalInput.focus(); });
    },

    closeModal() {
      this.modal.isOpen = false;
      this.modal.inputValue = '';
    },

    deleteScore() {
      const pIndex = this.modal.targetIndex;
      const key = this.modal.targetKey;
      this.players[pIndex].scores[key] = null;
      this.closeModal();
    },

    saveData() {
      const pIndex = this.modal.targetIndex;
      const key = this.modal.targetKey;
      let val = String(this.modal.inputValue).trim();

      if (this.modal.type === 'name') {
        if (val && val !== '') {
          this.players[pIndex].name = val;
        }
      } else if (this.modal.type === 'score') {

        // 빈 값이면 초기화(null)
        if (val === '' || val === 'null' || val === 'undefined') {
          this.players[pIndex].scores[key] = null;
        }
        else {
          // ==========================================
          // 5자리 입력된 경우: 주사위 5개 조합 자동 계산 로직
          // ==========================================
          if (val.length === 5) {

            // 1. 주사위 눈금 정합성 체크 (1~6 이외의 숫자가 섞여있으면 오류)
            if (!/^[1-6]{5}$/.test(val)) {
              alert("잘못 입력된 숫자입니다. 주사위의 눈은 1에서 6 사이여야 합니다.");
              return; // 모달 닫지 않고 중단
            }

            const dice = val.split('').map(Number);
            const sumAll = dice.reduce((a, b) => a + b, 0);

            // 2. 각 주사위 눈의 개수 집계
            const counts = {};
            dice.forEach(d => {
              counts[d] = (counts[d] || 0) + 1;
            });
            const countValues = Object.values(counts);

            // 3. 족보별 계산 로직 적용
            let calculatedScore = 0;

            if (key === 'aces') calculatedScore = (counts[1] || 0) * 1;
            else if (key === 'twos') calculatedScore = (counts[2] || 0) * 2;
            else if (key === 'threes') calculatedScore = (counts[3] || 0) * 3;
            else if (key === 'fours') calculatedScore = (counts[4] || 0) * 4;
            else if (key === 'fives') calculatedScore = (counts[5] || 0) * 5;
            else if (key === 'sixes') calculatedScore = (counts[6] || 0) * 6;
            else if (key === 'choice') {
              calculatedScore = sumAll;
            }
            else if (key === 'fourDice') {
              // 4개가 동일한 숫자가 존재하면 전체 합산, 아니면 0
              if (countValues.some(c => c >= 4)) calculatedScore = sumAll;
            }
            else if (key === 'fullHouse') {
              // 정확히 3개 동일 + 2개 동일일 때만 전체 합산
              if (countValues.includes(3) && countValues.includes(2)) calculatedScore = sumAll;
            }
            else if (key === 'sStraight') {
              // 중복 제거 후 오름차순 정렬하여 연속성 확인 (15점 고정)
              const uniqueDice = [...new Set(dice)].sort((a, b) => a - b).join('');
              if (uniqueDice.includes('1234') || uniqueDice.includes('2345') || uniqueDice.includes('3456')) {
                calculatedScore = 15;
              }
            }
            else if (key === 'lStraight') {
              // 중복 제거 후 오름차순 정렬하여 연속성 확인 (30점 고정)
              const uniqueDice = [...new Set(dice)].sort((a, b) => a - b).join('');
              if (uniqueDice.includes('12345') || uniqueDice.includes('23456')) {
                calculatedScore = 30;
              }
            }
            else if (key === 'yacht') {
              // 5개 숫자가 모두 동일하면 (50점 고정)
              if (countValues.some(c => c === 5)) calculatedScore = 50;
            }

            // 계산된 점수 반영
            this.players[pIndex].scores[key] = calculatedScore;

          }
              // ==========================================
              // 5자리가 아닌 경우: 기존 직접입력 (또는 보정) 로직
          // ==========================================
          else {
            let num = parseInt(val, 10);
            if (!isNaN(num)) {
              if (num !== 0) {
                if (key === 'aces' && num >= 5) num = 5;
                else if (key === 'twos' && num >= 10) num = 10;
                else if (key === 'threes' && num >= 15) num = 15;
                else if (key === 'fours' && num >= 20) num = 20;
                else if (key === 'fives' && num >= 25) num = 25;
                else if ((key === 'sixes'|| key === 'choice' || key === 'fourDice' || key === 'fullHouse' )&& num >= 30) num = 30;
                else if (key === 'sStraight') num = 15;
                else if (key === 'lStraight') num = 30;
                else if (key === 'yacht') num = 50;
              }
              this.players[pIndex].scores[key] = num;
            }
          }
        }
      }
      this.closeModal();
    },

    getUpperSum(pIndex) {
      const scores = this.players[pIndex].scores;
      const keys = ['aces', 'twos', 'threes', 'fours', 'fives', 'sixes'];
      return keys.reduce((acc, key) => acc + (scores[key] || 0), 0);
    },
    getBonus(pIndex) {
      return this.getUpperSum(pIndex) >= 63 ? 35 : 0;
    },
    getGrandTotal(pIndex) {
      const scores = this.players[pIndex].scores;
      const upperSum = this.getUpperSum(pIndex);
      const bonus = upperSum >= 63 ? 35 : 0;
      const lowerKeys = ['choice', 'fourDice', 'fullHouse', 'sStraight', 'lStraight', 'yacht'];
      const lowerSum = lowerKeys.reduce((acc, key) => acc + (scores[key] || 0), 0);
      return upperSum + bonus + lowerSum;
    }
  }
}
</script>

<style scoped>
/* SVG 색상 (기존 유지) */
.cls-1, .cls-8 { fill: #fefcef; }
.cls-2 { fill: #a8a8a8; }
.cls-3 { fill: #404040; }
.cls-4, .cls-5, .cls-6 { fill: none; stroke-width: 3px; }
.cls-4 { stroke: #e6e6e6; stroke-dasharray: 3 5; }
.cls-10, .cls-4, .cls-5, .cls-6, .cls-9 { stroke-miterlimit: 10; }
.cls-5 { stroke: #999; }
.cls-10, .cls-6, .cls-9 { stroke: #000; }
.cls-7 { fill: #e6e6e6; }
.cls-8 { font-size: 30px; }
.cls-10, .cls-8, .cls-9 { font-family: Pretendard-Regular, Pretendard, sans-serif; }
.cls-9 { font-size: 25px; }
.cls-10 { font-size: 20px; }
.cls-11 { letter-spacing: 0em; }

.score-card-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  overflow-x: auto;
  margin: 0 auto;
}

/* ▼▼▼ Turn 정보 박스 스타일 ▼▼▼ */
.turn-info-box {
  position: absolute;
  top: 0%;
  left: 0%;
  background: rgba(255, 255, 255, 0.9);
  padding: 10px 15px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.15);
  text-align: center;
  z-index: 10;
  border: 2px solid #00A1E1;
}

.turn-label {
  font-size: 0.9rem;
  font-weight: bold;
  color: #555;
  margin-bottom: 2px;
}

.turn-number {
  font-size: 1.8rem;
  font-weight: 900;
  color: #333;
  margin-bottom: 5px;
}

.turn-number .current {
  color: #00A1E1;
}

.next-turn-btn {
  background-color: #00A1E1;
  color: white;
  border: none;
  padding: 6px 12px;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s;
}

.next-turn-btn:hover {
  background-color: #0081b5;
}
/* ▲▲▲ Turn 스타일 끝 ▲▲▲ */

.interactive-svg {
  width: 100%;
  min-width: 800px;
  height: auto;
  user-select: none;
}

.score-text {
  font-family: 'Pretendard', sans-serif;
  font-size: 30px;
  fill: #aaa;
  text-anchor: middle;
  pointer-events: none;
}
.score-text.has-score { fill: #333; font-weight: bold; }
.score-text.is-locked { fill: #888; } /* 잠긴 점수는 약간 흐리게 */

.total-text {
  font-family: 'Pretendard', sans-serif;
  font-size: 32px;
  fill: #00A1E1;
  font-weight: 900;
  text-anchor: middle;
}
.total-text.bonus-text { fill: #555; }
.total-text.grand-total { fill: #E10000; font-size: 36px; }

.player-name-text {
  font-family: 'Pretendard', sans-serif;
  font-size: 20px;
  font-weight: bold;
  fill: #555;
  text-anchor: middle;
  pointer-events: none;
}

.click-area {
  fill: rgba(255, 255, 255, 0.01); /* 완전 투명 대신 거의 안 보이는 흰색 사용 */
  cursor: pointer;
  pointer-events: auto; /* 명시적으로 클릭 허용 */
}

.click-area:hover {
  fill: rgba(0, 161, 225, 0.1); /* 마우스 올렸을 때 살짝 파란색 */
}

/* 모달 스타일 */
.custom-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.custom-modal {
  background: white;
  padding: 20px;
  border-radius: 12px;
  width: 90%;
  max-width: 350px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
  text-align: center;
}
.custom-modal h3 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.2rem;
  color: #333;
}
.custom-modal input {
  width: 100%;
  padding: 12px;
  font-size: 1.2rem;
  border: 2px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
  box-sizing: border-box;
}
.custom-modal input::-webkit-outer-spin-button,
.custom-modal input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.modal-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.modal-buttons button {
  flex: 1;
  padding: 10px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
}
.btn-cancel { background-color: #f0f0f0; color: #555; }
.btn-confirm { background-color: #00A1E1; color: white; }

/* ▼▼▼ [추가] 불러오기 버튼 스타일 ▼▼▼ */
.load-btn {
  display: block; /* 줄바꿈 */
  margin-top: 5px;
  background-color: #fff;
  border: 1px solid #00A1E1;
  color: #00A1E1;
  padding: 4px 10px;
  font-size: 0.75rem;
  border-radius: 12px;
  cursor: pointer;
  width: 100%;
}
.load-btn:hover {
  background-color: #f0f8ff;
}

/* ▼▼▼ [추가] 게임 목록 리스트 스타일 ▼▼▼ */
.game-list-container {
  max-height: 300px;
  overflow-y: auto;
  text-align: left;
  margin-bottom: 15px;
}

.game-list-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.game-list-container li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  cursor: default; /* li 자체는 기본 커서 */
  transition: background 0.2s;
}

/* 왼쪽 정보 영역만 클릭 가능하게 표시 */
.game-info-wrapper {
  flex-grow: 1;
  cursor: pointer;
}

.game-list-container li:hover {
  background-color: #f9f9f9;
}

.game-info {
  display: flex;
  flex-direction: column;
}

.game-date {
  font-size: 0.9rem;
  font-weight: bold;
  color: #333;
}

.game-turn {
  font-size: 0.8rem;
  color: #888;
}

.arrow {
  color: #ccc;
}

.no-data {
  padding: 20px;
  color: #999;
}

.full-width {
  width: 100%;
}

/* ▼▼▼ [추가] 목록 삭제 버튼 스타일 ▼▼▼ */
.list-delete-btn {
  background-color: #fff;
  border: 1px solid #ff4d4f;
  color: #ff4d4f;
  padding: 4px 8px;
  font-size: 0.8rem;
  border-radius: 6px;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.2s;
}

.list-delete-btn:hover {
  background-color: #ff4d4f;
  color: white;
}

/* [추가] 리스트 필터 (체크박스) 영역 */
.list-filter {
  padding: 10px;
  border-bottom: 1px solid #eee;
  text-align: right;
  font-size: 0.9rem;
  color: #555;
}

.list-filter label {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}

.list-filter input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

/* [추가] 종료된 게임 텍스트 강조 */
.text-finished {
  color: #E10000 !important;
  font-weight: bold;
}

/* [추가] Read-Only 모드 (SVG 전체 클릭 방지) */
.interactive-svg.read-only {
  pointer-events: none; /* 모든 클릭 차단 */
  opacity: 0.9; /* 살짝 흐리게 해서 보기 전용임을 암시 (선택사항) */
}

/* [추가] GAME OVER 라벨 */
.finished-label {
  color: #E10000;
  font-weight: 900;
  font-size: 1.5rem;
}
@media (max-width: 768px) {

  /* [추가] Turn 박스를 모바일에서만 0.8배(80%)로 축소 */
  .turn-info-box {
    transform: scale(0.65);       /* 크기를 80%로 줄임 */
    transform-origin: top left;  /* 왼쪽 위를 기준으로 축소 (위치 어긋남 방지) */
    top: 0px;                    /* 상단 여백 미세 조정 */
    left: 0px;                   /* 좌측 여백 미세 조정 */
  }

  .score-card-container {
    max-width: 100%; /* 모바일에서는 너비 제한 해제 (꽉 차게) */
    margin: 0;       /* 여백 제거 */
    width: 100%;     /* 화면 전체 너비 사용 */
  }

  /* (선택사항) 모바일에서 SVG가 스크롤 없이 한 화면에 다 들어오게 하려면? */
  /* 단, 6명 플레이어 칸이 모바일에 다 들어오면 글씨가 매우 작아질 수 있습니다. */
  .interactive-svg {
    min-width: 100%;  /* 주석을 풀면 스크롤이 사라지고 축소되어 보입니다 */
  }
}
</style>
